"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _stencilReactDesc = require("@amzn/stencil-react-desc");
var _DetailedBox = _interopRequireDefault(require("../../_form/detailed-box/DetailedBox"));
var _helperComponents = require("../../_form/detailed-box/helperComponents");
var _utils = require("../../utils");
var _ = require("../");
var _propTypes = require("../propTypes");
var _helperComponents2 = require("./helperComponents");
var _react2 = require("@emotion/react");
const DetailedRadioWithoutDocs = _ref => {
  let {
    colorScheme = _.RadioColorScheme.Default,
    details,
    disabled,
    error,
    id,
    titleText,
    renderTitle,
    ...props
  } = _ref;
  const dataTestProps = (0, _utils.buildDataTestProps)({
    dataTestComponent: props['data-test-component'],
    dataTestId: props['data-test-id'] || titleText
  });
  return (0, _react2.jsx)(_helperComponents.WrapperLabel, (0, _extends2.default)({
    htmlFor: id
  }, dataTestProps), (0, _react2.jsx)(_DetailedBox.default, {
    details: details,
    disabled: disabled,
    error: error,
    isInverted: colorScheme === _.RadioColorScheme.Inverted,
    titleText: titleText,
    renderTitle: renderTitle
  }, (0, _react2.jsx)(_helperComponents2.DetailedRadioHidden, (0, _extends2.default)({
    type: "radio"
  }, props, {
    className: "stencilDetailedRadioHidden",
    "data-test-component": "DetailedRadioInput",
    "data-test-id": props.value,
    disabled: disabled,
    id: id
  })), (0, _react2.jsx)(_helperComponents2.DetailedRing, {
    disabled: disabled,
    error: error
  })));
};
const DetailedRadioWithDocs = (0, _stencilReactDesc.describe)(DetailedRadioWithoutDocs).description('Radio button with more detailed and lengthy explanation');
DetailedRadioWithDocs.propTypes = {
  ..._propTypes.sharedRadioPropTypes,
  details: _stencilReactDesc.PropTypes.oneOfType([_stencilReactDesc.PropTypes.string, _stencilReactDesc.PropTypes.node]).description('Body text of the radio button. Should be more detailed explanation of the option.'),
  disabled: _stencilReactDesc.PropTypes.bool.description('Prevents the user from interacting with the detailed radio button.'),
  error: _stencilReactDesc.PropTypes.bool.description('Styles the detailed radio button to indicate that the value is incorrect.'),
  titleText: _stencilReactDesc.PropTypes.string.description('Title of the radio button. Should be a short description of the option.'),
  renderTitle: _stencilReactDesc.PropTypes.func.description('Customizes how the title is displayed.').format("({\n  titleText: string\n}) => ReactNode")
};
const DetailedRadio = (0, _utils.withTestAttributes)({
  component: 'StencilDetailedRadio'
})(DetailedRadioWithDocs);
DetailedRadio.displayName = 'DetailedRadio';
var _default = exports.default = DetailedRadio;